import { Link } from 'react-router-dom';

export default function FooterSection() {
  return (
    <footer className="py-16 px-6 md:px-10 bg-foreground-950">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="font-heading text-2xl font-bold text-white mb-4">
              OOPBuy Spreadsheet
            </h3>
            <p className="text-foreground-400 text-sm leading-relaxed max-w-xs">
              Die größte deutschsprachige Übersicht für OOPBuy Spreadsheet, Produkte, Finds und
              Einkaufsanleitungen. Wir helfen Nutzern dabei, OOPBuy Produkte schneller zu finden,
              besser zu vergleichen und sicherer einzukaufen.
            </p>
          </div>

          <div className="space-y-6">
            <div>
              <h4 className="text-foreground-500 text-xs font-semibold uppercase tracking-wider mb-2">
                Schnellzugriff
              </h4>
              <ul className="space-y-1">
                <li>
                  <Link
                    to="/"
                    className="text-foreground-300 text-sm hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    Startseite
                  </Link>
                </li>
                <li>
                  <Link
                    to="/artikel/oopbuy-spreadsheet-guide"
                    className="text-foreground-300 text-sm hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    OOPBuy Spreadsheet Guide
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div>
            <h4 className="text-foreground-500 text-xs font-semibold uppercase tracking-wider mb-2">
              Hauptportal
            </h4>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-300 text-sm hover:text-white transition-colors duration-200 cursor-pointer"
            >
              kaspreadsheet.com
            </a>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} OOPBuy Spreadsheet Deutschland. Alle Rechte
            vorbehalten.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/"
              className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors duration-200 cursor-pointer"
            >
              Home
            </Link>
            <Link
              to="/artikel/oopbuy-spreadsheet-guide"
              className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors duration-200 cursor-pointer"
            >
              Guide
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors duration-200 cursor-pointer"
            >
              Hauptseite
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}